// components/WelcomeOverlay.jsx
import React, { useState, useEffect } from "react";

const WelcomeOverlay = ({ onClose }) => {
  const [visible, setVisible] = useState(true);

  useEffect(() => {
    const handleKeyPress = (event) => {
      setVisible(false);
      onClose();
    };

    const handleMouseClick = () => {
      setVisible(false);
      onClose();

    };

    window.addEventListener("keydown", handleKeyPress);
    window.addEventListener("click", handleMouseClick);

    return () => {
      window.removeEventListener("keydown", handleKeyPress);
      window.removeEventListener("click", handleMouseClick);
    };
  }, [onClose]);

  return (
    visible && (
      <div
        style={{
          position: "fixed",
          top: 0,
          left: 0,
          width: "100%",
          height: "100%",
          background: "rgba(10,10,20, 0.90)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          zIndex: 9999, 
          animation: `
            @keyframes fadeOut {
              0% {
                opacity: 1;
              }
              100% {
                opacity: 0;
              }
            }
            fadeOut 5s ease forwards `, 
        }}
      >
    <div
        style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        position: "relative",
        top: 0,
        left: 0,
        width: "30%",
        height: "30%",
        padding: "40px",
        background: 'linear-gradient(to bottom, rgb(170, 15, 50), rgb(130, 15, 15))',
        background: "linear-gradient(to bottom right, rgb(160,10,10,0.85), rgb(70, 15,80,0.85))", 
        color: 'white', 
        textShadow: "-1px 1px 0 rgba(10, 10, 10), 1px 1px 0 rgba(10, 10, 10), 1px -1px 0 rgba(10, 10, 10), -1px -1px 0 rgba(10, 10, 10)", 
        borderRadius: "5px",
        boxShadow: "0px 0px 10px rgba(0, 0, 0, 0.5)",
        textAlign: "center",
        outline: "2px solid rgb(170,170,200)", 
        width: "100%",
        maxWidth: "600px", // Set a maximum width for the div
        boxSizing: "border-box", // Include padding and border in the width
        padding: "40px",
        width: "600px",
        maxWidth: "90%", 
        height: "min-content",
        }}
    >

        <div style={{ background: "", display: "block", padding: "10px 0px 20px 0px", fontFamily:"Arial, sans-serif", boxSizing:"border-box"
        }}>
            <h3 style={{ marginBottom: "40px", textDecoration: "underline", letterSpacing: "0.5px" }}>
              Welcome to the Create Posts App
            </h3>
            <p style={{marginBottom:"40px"}}>The app to create, read, edit and delete your own user created posts</p>
            <p>Note: Please allow up to 30 seconds for the server to load</p>
            <p style={{ marginTop: "40px" }}>Press any key or click here to continue...</p>

          </div>
        </div>
      </div>
    )
  );
};

export default WelcomeOverlay;


// components/WelcomeOverlay.jsx